$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  let locationId = $("body").attr("event_id");
  let productType = $("body").attr("product_type") == 1 ? "extra" : "product";
  let status = 1;

  if (p === "text_product_extra") {
    $(document).on(
      "click",
      "#update-text-product-extra-button, #product-extra-text-new-button",
      function (e) {
        e.preventDefault();
        const textProductExtraId = $(this).attr("data-update-id") ?? null;

        $.ajax({
          type: "POST",
          url: "/api/v1/private/product-extra/get-update-form",
          data: {
            text_product_extra_id: textProductExtraId,
          },
        })
          .done(function (data) {
            if (data && data.html) {
              if ($("#model-extra-product-text").length > 0) {
                $("#model-extra-product-text").remove();
              }
              $("#content").append(data.html);
              setTimeout(() => {
                $("#model-extra-product-text").modal("show");
              }, 300);
            } else {
              const errorHtml = `<div class="alert alert-danger alert-dismissible mt-2" id="message"><a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>'
              Kunne ikke opprette teksttillegg
              </div>`;
              $("#text-product-extra-form").after(errorHtml);
            }
          })
          .fail(function (data) {
            if (data && !data.success) {
              console.log("fail");

              const errorHtml = `<div class="alert alert-danger alert-dismissible" id="message"><a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>'
             Kunne ikke opprette teksttillegg
              </div>`;
              $("#text-product-extra-form").after(errorHtml);
            }
          })
          .always(function () {});
      },
    );

    $(document).on("submit", "#text-product-extra-form", function (e) {
      e.preventDefault();

      const formData = new FormData(e.target);
      const textExtraProductName = formData.get("text-extra-product-name");
      const textExtraProductId = formData.get("text-product-extra-id");

      $.ajax({
        type: "POST",
        url: "/api/v1/private/product-extra/save-text-product-extra",
        data: {
          name: textExtraProductName,
          text_product_extra_id: textExtraProductId,
          event_id: locationId,
          status: 1,
        },
      })
        .done(function (data) {
          if (data && data.success && data.html) {
            popupAlert();
            $("#text-extra-product-name").val("");
            $("#model-extra-product-text").modal("hide");
            $("#text-extra-product-list-view").empty();
            $("#text-extra-product-list-view").html(data.html);
          } else {
            const errorHtml = `<div class="alert alert-danger alert-dismissible mt-2" id="message"><a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>'
              Kunne ikke opprette teksttillegg
              </div>`;
            $("#text-product-extra-form").after(errorHtml);
          }
        })
        .fail(function (data) {
          if (data && !data.success) {
            console.log("fail");

            const errorHtml = `<div class="alert alert-danger alert-dismissible" id="message"><a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>'
             Kunne ikke opprette teksttillegg
              </div>`;
            $("#text-product-extra-form").after(errorHtml);
          }
        })
        .always(function () {});
    });

    $(document).on("click", "#text-productExtra-delete-btn", function (e) {
      e.preventDefault();
      const status = 0;
      const textExtraProductId = $(this).attr("data-delete-id");
      $.ajax({
        type: "POST",
        url: "/api/v1/private/product-extra/delete-text-product-extra",
        data: {
          text_product_extra_id: textExtraProductId,
          status,
          event_id: locationId,
        },
      })
        .done(function (data) {
          if (data && data.success && data.html) {
            popupAlert();
            $("#text-extra-product-list-view").empty();
            $("#text-extra-product-list-view").html(data.html);
          } else {
            const errorHtml = `<div class="alert alert-danger alert-dismissible mt-2" id="message"><a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>'
              Kunne ikke opprette teksttillegg
              </div>`;
            $("#text-product-extra-form").after(errorHtml);
          }
        })
        .fail(function (data) {
          if (data && !data.success) {
            console.log("fail");

            const errorHtml = `<div class="alert alert-danger alert-dismissible" id="message"><a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>'
             Kunne ikke opprette teksttillegg
              </div>`;
            $("#text-product-extra-form").after(errorHtml);
          }
        })
        .always(function () {});
    });
  }
});
